import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class RelatedInterviewSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('[data-js="related-slide"]'),
    this.dom.slides = this.dom.slider.querySelectorAll('.splide__slide');

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.jump = 0;

    this.slider = null;

    this.option = {
      autoplay: true,
      // autoWidth: true,
      focus: 'center',
      type: 'loop',
      rewind: true,
      perPage: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      // drag: false,
      interval: 5000,
      speed: 2000,
      arrows: false,
      pagination: false,
      padding: `${52.5 / 375 * 100}vw`,
      gap: `${20 / 375 * 100}%`,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 3,
          padding: `${180 / 1440 * 100}vw`,
          gap: `${36 / 1440 * 100}vw`,
        }
      }
    };

    this.init();
  }

  init() {

    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();

    // // ブレイクポイントの瞬間に発火
    // this.mql.addListener(this.checkBreakPoint);
    // // 初回チェック
    // this.checkBreakPoint(this.mql);
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');

      if (this.slider.secondary) {
        this.slider.secondary.destroy();
        this.slider.secondary = null;
      }

      this.slider.refresh();
      this.slider.third.refresh();
      // this.slider.fourth.go(this.slider.index + 1);
      const { Move } = this.slider.fourth.Components;
      this.jump = this.slider.index + 1;
      Move.jump(this.jump);
      this.slider.fourth.refresh();
      console.log('this.slider.index', this.slider.index, this.jump);
      
      return;
    } else {
      // console.log('pc');
      
      if (!this.slider.secondary) {
        this.option.secondary.start = this.slider.index;
        this.slider.secondary = new Splide(this.dom.slider.secondary, this.option.secondary);
        this.slider.secondary.mount();
      }
      this.option.fourth.start = 2;

      console.log(this.slider.index)
      this.slider.refresh();
      this.slider.secondary.refresh();
      this.slider.third.refresh();
      // this.slider.fourth.go(this.slider.index + 2);
      
      const { Move } = this.slider.fourth.Components;
      this.jump = this.slider.index + 2;
      Move.jump(this.jump);
      this.slider.fourth.refresh();
      console.log('this.slider.index', this.slider.index, this.jump);

      return;
		}
	}
}

export default RelatedInterviewSlides